import { Grid } from "@chakra-ui/layout";
import type {
  BrandProfitAndRevenueSummaryQuery,
  ProjectProfitAndRevenueSummaryQuery,
} from "@src/__generated__/urql-graphql";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";
import { ProfitCard } from "../../../common/components/profit-card";
import { RevenueCard } from "../../../common/components/revenue-card";
import type { ProjectReportStore } from "../../../project/common/store";

type Props = {
  summary:
    | ProjectProfitAndRevenueSummaryQuery["projectRevenueSummary"]
    | BrandProfitAndRevenueSummaryQuery["brandRevenueSummary"]
    | undefined;
  isFetching: boolean;
  expenseBudgetCategories: ProjectReportStore["expenseBudgetCategories"];
};

export const Summary: FunctionComponent<Props> = observer(
  function SummaryItems({ summary, isFetching, expenseBudgetCategories }) {
    return (
      <Grid templateColumns="0.5fr 0.5fr" p="4" columnGap="4">
        <RevenueCard
          isFetching={isFetching}
          summary={summary}
          type="project"
          isResponsive
          expenseBudgetCategories={expenseBudgetCategories}
        />
        <ProfitCard
          isFetching={isFetching}
          summary={summary}
          isResponsive
          expenseBudgetCategories={expenseBudgetCategories}
        />
      </Grid>
    );
  },
);
